import { BorrowerContent } from "../../content/borrower/borrowersList";
import { Layout } from "../../layout/page";

export function Borrower() {
  return (
    <Layout>
      <BorrowerContent />
    </Layout>
  );
}
